<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('tenant.properties') }}</router-link> /
            <span class="color-main">{{ $t('tenant.addTenant') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('tenant.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box-pad mb-3">
        <div class="col-md-8 col-12 margin-auto">
          <div class="flex-wrap-main">
            <div
              class="flex-sm-gap pointer-click"
              @click="backStep"
              :class="{ active: firstStep || secondStep }"
            >
              <div class="nub-circle">1</div>
              <div>{{ $t('tenant.personalData') }}</div>
            </div>
            <div class="line-step"></div>
            <div
              class="flex-sm-gap pointer-click"
              @click="checkAllIsValid"
              :class="{ active: secondStep }"
            >
              <div class="nub-circle">2</div>
              <div>{{ $t('tenant.rentalData') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('tenant.addTenantTitle') }}</div>
        <div class="main-body-box">
          <v-form @submit.prevent="addTenant" v-model="valid" ref="form">
            <div class="col-md-8 col-12">
              <div class="firstStep" v-show="firstStep">
                <div class="flex-group-me mb-4">
                  <div
                    class="profile-img-cont"
                    :class="{ inputDanger: imgInputValid }"
                  >
                    <img :src="profileImg" alt="" class="profileImg" />
                    <keep-alive>
                      <input
                        name="image"
                        type="file"
                        id="imageInput"
                        hidden
                        ref="imgInput"
                        accept="image/*"
                        @change="uploadImage"
                      />
                    </keep-alive>
                    <label for="imageInput" class="labelImg">
                      <i class="fa-regular fa-pen-to-square"></i>
                    </label>
                  </div>
                </div>
                <!-- <div class="dangerError text-center" v-if="imgInputValid">
                  الصورة مطلوبة
                </div> -->
                <div class="main-input-cont mb-3">
                  <h6 class="mb-2 font14">{{ $t('tenant.selectOldTenant') }}</h6>
                  <Dropdown
                    v-model="selectedUser"
                    :options="users"
                    filter
                    @change="getUserData"
                    optionLabel="name"
                    :placeholder="$t('tenant.selectOldTenantPlaceholder')"
                    :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                    class="main-select"
                  />
                </div>
                <div
                  class="main-input-cont mb-3 mt-1 tel-input-me no-details"
                  :class="{ inputDanger: PhoneValid }"
                >
                  <h6 class="mb-2 font14">{{ $t('tenant.phone') }}</h6>
                  <v-text-field
                    v-model="phone"
                    name="phone"
                    @input="checkPhoneValidation"
                    type="number"
                    min="0"
                    :placeholder="$t('tenant.phonePlaceholder')"
                  ></v-text-field>
                  <div class="dangerError" v-if="PhoneValid">
                    <span v-if="!phone || phone === null || phone === undefined">{{ $t('tenant.phoneRequired') }}</span>
                    <span v-else-if="phone.length < 9">{{ $t('tenant.phoneMinLength') || 'Phone must be at least 9 digits' }}</span>
                    <span v-else-if="phone.length > 11">{{ $t('tenant.phoneMaxLength') || 'Phone must be at most 11 digits' }}</span>
                  </div>
                  <div class="drop-countries">
                    <Dropdown
                      v-model="selectedCountry"
                      :options="countries"
                      optionLabel="name"
                    >
                      <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex-group-me">
                          <img
                            :alt="slotProps.value.label"
                            :src="slotProps.value.image"
                            :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                            style="width: 24px"
                          />
                          <div>{{ slotProps.value.key }}</div>
                        </div>
                        <span v-else>
                          {{ slotProps.placeholder }}
                        </span>
                      </template>
                      <template #option="slotProps">
                        <div class="flex-group-me">
                          <img
                            :alt="slotProps.option.label"
                            :src="slotProps.option.image"
                            :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                            style="width: 24px"
                          />
                          <div>{{ slotProps.option.key }}</div>
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                </div>
                <div class="main-input-cont mt-1 mb-3 no-details">
                  <h6 class="mb-2 font14">{{ $t('tenant.nameAr') }}</h6>
                  <v-text-field
                    type="text"
                    name="name[ar]"
                    v-model="ArName"
                    @input="checkArNameValidation; preventLeadingSpace('ArName', $event)"
                    :placeholder="$t('tenant.nameArPlaceholder')"
                  ></v-text-field>
                  <div class="dangerError" v-if="ArNameValid">
                    {{ $t('tenant.nameArRequired') }}
                  </div>
                </div>
                <div class="main-input-cont mt-1 mb-3 no-details">
                  <h6 class="mb-2 font14">{{ $t('tenant.nameEn') }}</h6>
                  <v-text-field
                    v-model="EnName"
                    name="name[en]"
                    @input="checkEnNameValidation; preventLeadingSpace('EnName', $event)"
                    type="text"
                    :placeholder="$t('tenant.nameEnPlaceholder')"
                  ></v-text-field>
                  <div class="dangerError" v-if="EnNameValid">
                    {{ $t('tenant.nameEnRequired') }}
                  </div>
                </div>
                <div class="main-input-cont mt-1 mb-3 no-details">
                  <h6 class="mb-2 font14">{{ $t('tenant.email') }}</h6>
                  <v-text-field
                    type="email"
                    name="email"
                    @input="checkEmailValidation; preventLeadingSpace('email', $event)"
                    v-model="email"
                    :placeholder="$t('tenant.emailPlaceholder')"
                  ></v-text-field>
                  <div class="dangerError" v-if="emailValid">
                    {{ $t('tenant.emailRequired') }}
                  </div>
                </div>

                <div class="main-input-cont mb-3">
                  <h6 class="mb-2 font14">{{ $t('tenant.city') }}</h6>
                  <Dropdown
                    v-model="selectedCity"
                    :options="cities"
                    @change="checkCityValidation"
                    filter
                    optionLabel="name"
                    :placeholder="$t('tenant.cityPlaceholder')"
                    :emptyFilterMessage="$t('noData.noDataToShow')"
                    :emptyMessage="$t('noData.noDataToShow')"
                    class="main-select"
                  />
                  <div class="dangerError" v-if="cityValid">{{ $t('tenant.cityRequired') }}</div>
                </div>

                <div
                  class="main-input-cont mt-1 mb-3 no-details"
                  v-if="showPasswords"
                >
                  <h6 class="mb-2 font14">{{ $t('tenant.password') }}</h6>
                  <v-text-field
                    v-model="password"
                    name="password"
                    @input="checkPasswordValidation"
                    type="password"
                    :placeholder="$t('tenant.passwordPlaceholder')"
                  ></v-text-field>

                  <div
                    class="absLeft pointer-click"
                    @click="toogleEyeIcon($event)"
                  >
                    <div class="normalEye">
                      <i class="fa-regular fa-eye"></i>
                    </div>
                    <div class="slashedEye">
                      <i class="fa-regular fa-eye-slash"></i>
                    </div>
                  </div>
                  <div class="dangerError" v-if="passwordValid">
                    <span v-if="!password || password === null || password === undefined">{{ $t('tenant.passwordRequired') }}</span>
                    <span v-else-if="password.length < 6">{{ $t('tenant.passwordMinLength') || 'Password must be at least 6 characters' }}</span>
                  </div>
                </div>
                <div
                  class="main-input-cont mt-1 mb-3 no-details"
                  v-if="showPasswords"
                >
                  <h6 class="mb-2 font14">{{ $t('tenant.confirmPassword') }}</h6>
                  <v-text-field
                    v-model="passwordConfirm"
                    name="password_confirmation"
                    @input="checkPasswordConfirmValidation"
                    type="password"
                    :placeholder="$t('tenant.confirmPasswordPlaceholder')"
                  ></v-text-field>

                  <div
                    class="absLeft pointer-click"
                    @click="toogleEyeIcon($event)"
                  >
                    <div class="normalEye">
                      <i class="fa-regular fa-eye"></i>
                    </div>
                    <div class="slashedEye">
                      <i class="fa-regular fa-eye-slash"></i>
                    </div>
                  </div>
                  <div class="dangerError" v-if="passwordConfirmValid">
                    {{ $t('tenant.confirmPasswordRequired') }}
                  </div>
                </div>
                <button
                  type="button"
                  class="main-btn up lg mt-4"
                  @click="checkAllIsValid"
                >
                  {{ $t('tenant.confirm') }}
                </button>
              </div>
              <div class="secondStep" v-show="secondStep">
                <div class="row">
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont calender-main">
                      <h6 class="mb-2 font14">{{ $t('tenant.rentStartDate') }}</h6>
                      <Calendar
                        v-model="dateBegin"
                        :placeholder="$t('tenant.rentStartDatePlaceholder')"
                        dateFormat="dd/mm/yy"
                        :minDate="minDate"
                        :maxDate="dateEnd ? new Date(dateEnd.getTime() - 24 * 60 * 60 * 1000) : null"
                        @date-select="validateDateBegin"
                      />
                      <div class="abs-lef-none">
                        <i class="fa-regular fa-calendar-days"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont calender-main">
                      <h6 class="mb-2 font14">{{ $t('tenant.rentEndDate') }}</h6>
                      <Calendar
                        v-model="dateEnd"
                        :placeholder="$t('tenant.rentEndDatePlaceholder')"
                        dateFormat="dd/mm/yy"
                        :minDate="dateBegin ? new Date(dateBegin.getTime() + 24 * 60 * 60 * 1000) : minDate"
                        @date-select="validateDateEnd"
                      />
                      <div class="abs-lef-none">
                        <i class="fa-regular fa-calendar-days"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont calender-main">
                      <h6 class="mb-2 font14">{{ $t('tenant.rentDueDate') }}</h6>
                      <Calendar
                        v-model="dateReal"
                        :placeholder="$t('tenant.rentDueDatePlaceholder')"
                        dateFormat="dd/mm/yy"
                      />
                      <div class="abs-lef-none">
                        <i class="fa-regular fa-calendar-days"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont">
                      <h6 class="mb-2 font14">{{ $t('tenant.rentPeriod') }}</h6>
                      <Dropdown
                        v-model="selectedRound"
                        :options="rounds"
                        optionLabel="period"
                        :placeholder="$t('tenant.rentPeriodPlaceholder')"
                        :emptyFilterMessage="$t('noData.noDataToShow')"
                        :emptyMessage="$t('noData.noDataToShow')"
                        class="main-select"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont no-details">
                      <h6 class="mb-2 font14">{{ $t('tenant.rentAmount') }}</h6>
                      <v-text-field
                        name="price"
                        type="text"
                        :placeholder="$t('tenant.rentAmountPlaceholder')"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 mb-3">
                    <div class="main-input-cont no-details">
                      <h6 class="mb-2 font14">{{ $t('tenant.electricInvoice') }}</h6>
                      <v-text-field
                        name="electric_invoice"
                        type="number"
                        min="0"
                        v-model="electricInvoice"
                        @input="numbersOnly('electricInvoice', $event)"
                        :placeholder="$t('tenant.electricInvoicePlaceholder')"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <div class="main-input-cont no-details">
                      <h6 class="mb-2 font14">{{ $t('tenant.apartmentNumber') }}</h6>
                      <v-text-field
                        name="flat_number"
                        type="number"
                        min="0"
                        v-model="flatNumber"
                        @input="numbersOnly('flatNumber', $event)"
                        :placeholder="$t('tenant.apartmentNumberPlaceholder')"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="main-input-cont mb-3">
                  <h6 class="mb-3 font14">{{ $t('tenant.consumptions') }}</h6>
                  <div class="flex-big-gap">
                    <div class="flex-sm-gap">
                      <input
                        type="checkbox"
                        v-model="electric_use"
                        class="main-check"
                        id="elec"
                      />
                      <label for="elec" class="check-label"
                        >{{ $t('tenant.electricBill') }}</label
                      >
                    </div>
                    <div class="flex-sm-gap">
                      <input
                        type="checkbox"
                        class="main-check"
                        v-model="water_use"
                        id="water"
                      />
                      <label for="water" class="check-label">{{ $t('tenant.waterBill') }}</label>
                    </div>
                  </div>
                </div>
                <div class="main-input-cont inline-files">
                  <div class="label-title mb-2">{{ $t('tenant.apartmentContract') }}</div>
                  <div class="upload-all-div">
                    <uploadFileSingle
                      name="contract"
                      id="uploadbuildingpaper"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  :disabled="disabled"
                  class="main-btn up lg mt-4"
                >
                  <div v-if="!disabled">{{ $t('tenant.add') }}</div>
                  <div class="loading" role="status" v-if="disabled">
                    {{ $t('tenant.adding') }}
                    <div class="spinner-small-white" v-if="disabled"></div>
                  </div>
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </main>
  <!-- success modal  -->
  <!-- <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        تم اضافة العقار بنجاح
      </h6>
      <div class="flex-group-me mb-2">
        <router-link to="/" class="main-btn lg up">
          اضافة مستاجرين
        </router-link>
        <router-link to="/" class="main-btn lg up trans">
          تفاصيل العقار
        </router-link>
      </div>
    </div>
  </Dialog> -->
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import uploadFileSingle from "../components/dashboard/uploadFileSingle.vue";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
// import Dialog from "primevue/dialog";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const route = useRoute();
import { useRoute } from "vue-router";
import moment from "moment";

// reactive state

// const successImg = ref(require("../assets/imgs/check.png"));
// const showMap = ref(false);
const profileImg = ref(require("../assets/imgs/solia.jpg"));
const dateBegin = ref("");
const dateReal = ref("");
const dateEnd = ref("");
const showPasswords = ref(true);
const firstStep = ref(true);
const secondStep = ref(false);
const disabled = ref(false);
const form = ref(null);
// const showSuccess = ref(false);
// validation
const PhoneValid = ref(false);
const ArNameValid = ref(false);
const EnNameValid = ref(false);
const emailValid = ref(false);
const cityValid = ref(false);
const passwordValid = ref(false);
const passwordConfirmValid = ref(false);
// const imgInputValid = ref(false);

const water_use = ref(null);
const electric_use = ref(null);
const phone = ref(null);
const ArName = ref("");
const EnName = ref("");
const email = ref("");
const password = ref("");
const electricInvoice = ref("");
const flatNumber = ref("");
const passwordConfirm = ref("");
const imgInput = ref(null);
const cities = ref([]);
const selectedCity = ref(null);
const selectedCountry = ref({
  key: "966",
  code: "SA",
  image:
    "https://backend.maak-lancer.com/public/storage/images/countries/1701785725_8987.png",
});
const countries = ref([]);
const minDate = ref(new Date()); // Today's date as minimum
const selectedRound = ref(null);
const rounds = ref([]);
const selectedUser = ref(null);
const users = ref([]);

// functions
function getUserData() {
  phone.value = selectedUser.value.phone;
  email.value = selectedUser.value.email;
  ArName.value = selectedUser.value.name_ar;
  EnName.value = selectedUser.value.name_en;
  selectedCountry.value.key = selectedUser.value.country_code;
  selectedCity.value = selectedUser.value.city;
  showPasswords.value = false;
}
function addTenant() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);

  fd.append("building_id", route.params.id);
  if (dateBegin.value) {
    fd.append("start", moment(dateBegin.value).format("YYYY-MM-DD"));
  }
  if (dateEnd.value) {
    fd.append("end", moment(dateEnd.value).format("YYYY-MM-DD"));
  }
  if (dateReal.value) {
    fd.append("pay_date", moment(dateReal.value).format("YYYY-MM-DD"));
  }
  if (selectedCountry.value) {
    fd.append("country_code", Number(selectedCountry.value.key));
  }
  if (selectedCity.value) {
    fd.append("city_id", selectedCity.value.id);
  }
  if (selectedRound.value) {
    fd.append("period_id", selectedRound.value.id);
  }
  if (selectedUser.value) {
    fd.append("user_id", selectedUser.value.id);
  }

  fd.append("electric_use", Number(electric_use.value));
  fd.append("water_use", Number(water_use.value));

  axios
    .post("/manager/add-rental", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        setTimeout(function () {
          router.push(`/buildingDetails/${route.params.id}`);
        }, 500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function getCities() {
  axios.get("/cities").then((response) => {
    cities.value = response.data.data;
  });
}
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
  });
}
function getPeriods() {
  axios
    .get("/manager/periods", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      rounds.value = response.data.data;
    });
}
function getUsers() {
  axios
    .get("/manager/all-users", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      users.value = response.data.data;
      console.log(response.data);
    });
}

// upload single umg
function uploadImage(e) {
  const file = e.target.files[0];
  if (e.target.files[0]) {
    profileImg.value = URL.createObjectURL(file);
  } else {
    profileImg.value = require("../assets/imgs/solia.jpg");
  }
  // checkImgValidation();
}
// toggle eye icon
function toogleEyeIcon(event) {
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}

// back step
function backStep() {
  secondStep.value = false;
  firstStep.value = true;
}
// validation
// phone Validition
// function checkImgValidation() {
//   if (!imgInput.value.value) {
//     imgInputValid.value = true;
//   } else {
//     imgInputValid.value = false;
//   }
// }
function checkPhoneValidation() {
  if (!phone.value || phone.value === null || phone.value === undefined) {
    PhoneValid.value = true;
  } else if (phone.value.length < 9 || phone.value.length > 11) {
    PhoneValid.value = true;
  } else {
    PhoneValid.value = false;
  }
}
function checkArNameValidation() {
  if (!ArName.value.length) {
    ArNameValid.value = true;
  } else {
    ArNameValid.value = false;
  }
}
function checkEnNameValidation() {
  if (!EnName.value.length) {
    EnNameValid.value = true;
  } else {
    EnNameValid.value = false;
  }
}
function checkCityValidation() {
  if (!selectedCity.value) {
    cityValid.value = true;
  } else {
    cityValid.value = false;
  }
}

// Function to prevent leading spaces
function preventLeadingSpace(field, event) {
  const value = event.target.value;
  // Remove leading spaces
  const trimmedValue = value.replace(/^\s+/, '');
  // Update the field value
  if (field === 'ArName') ArName.value = trimmedValue;
  if (field === 'EnName') EnName.value = trimmedValue;
  if (field === 'email') email.value = trimmedValue;
}

// Function to allow numbers only
function numbersOnly(field, event) {
  const value = event.target.value;
  // Remove non-numeric characters
  const numericValue = value.replace(/[^0-9]/g, '');
  // Update the field value
  if (field === 'electricInvoice') electricInvoice.value = numericValue;
  if (field === 'flatNumber') flatNumber.value = numericValue;
}
function checkPasswordValidation() {
  if (!password.value || password.value === null || password.value === undefined) {
    passwordValid.value = true;
  } else if (password.value.length < 6) {
    passwordValid.value = true;
  } else {
    passwordValid.value = false;
  }
}
function checkPasswordConfirmValidation() {
  if (!passwordConfirm.value || passwordConfirm.value != password.value) {
    passwordConfirmValid.value = true;
  } else {
    passwordConfirmValid.value = false;
  }
}
function checkEmailValidation() {
  if (
    !email.value.length ||
    !email.value
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  ) {
    emailValid.value = true;
  } else {
    emailValid.value = false;
  }
}

// Date validation functions
function validateDateBegin() {
  if (dateBegin.value && dateEnd.value) {
    // Ensure dateBegin is always before dateEnd
    if (dateBegin.value >= dateEnd.value) {
      // Clear dateEnd if it's not after dateBegin
      dateEnd.value = null;
    }
  }
}

function validateDateEnd() {
  if (dateEnd.value && dateBegin.value) {
    // Ensure dateEnd is always after dateBegin
    if (dateEnd.value <= dateBegin.value) {
      // Clear dateEnd if it's not after dateBegin
      dateEnd.value = null;
    }
  }
}

function checkAllIsValid() {
  checkPasswordConfirmValidation();
  checkPhoneValidation();
  checkArNameValidation();
  checkEnNameValidation();
  checkCityValidation();
  checkPasswordValidation();
  checkEmailValidation();
  // checkImgValidation();
  setTimeout(function () {
    if (document.querySelector(".dangerError")) {
      return false
    } else {
      secondStep.value = true;
      firstStep.value = false;
    }
  });
}

// lifecycle hooks
onMounted(() => {
  getCountries();
  getCities();
  getPeriods();
  getUsers();
});
</script>
